export default {
      id: "forme_titre-usage",
      viewBox: "0 0 30 40",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#forme_titre-usage",
      toString: function () {
        return this.url;
      }
    }